import { useRef, useCallback, useLayoutEffect } from 'react';

/**
 * 此hooks功能：传入一个方法，返回一个类型一摸一样的方法，但是返回的方法引用不会变化，并且如果方法内使用了一些会变化的变量，也能够实时获取到最新的值
 *
 * 1.用于优化性能，类似于useCallback, 但是不需要像useCallback一样传入依赖
 * 2.解决useCallback的依赖困境，可以不关注依赖而获取内部使用变量的最新值
 *
 */
const useCacheCallback = <T extends (...args: any[]) => void>(callBack: T) => {
    const handle = useRef<T>();

    useLayoutEffect(() => {
        handle.current = callBack;
    });

    const cacheCallBack = useCallback(
        ((...args) => {
            if (handle.current) {
                return handle.current(...args);
            }
        }) as T,
        []
    );

    return cacheCallBack;
};

export default useCacheCallback;
